<rask-fieldset-toggle
    label="Nås från väg"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-checkbox-list
        label="Nås från väg"
        [formControlName]="name"
        [items]="options"
        [selected]="control.value">
    </rask-checkbox-list>
</rask-fieldset-toggle>